import React, { useEffect } from 'react';
import { signupErrorRedirect } from '../../../utils/ErrorHandling';
import { useSelector } from 'react-redux';
import { selectRedirectError } from '../../../features/redirectError/redirectErrorSlice';

type Props = {
  children: React.ReactNode;
};

export const RegistrationErrorHandler: React.FC<Props> = (props) => {
  const error = useSelector(selectRedirectError);

  useEffect(() => {
    if (error && error.error) {
      signupErrorRedirect(error);
    }
  }, [error]);

  return <>{props.children}</>;
};
